
import PreprDocument from "./Document.vue"
import PreprPhoto from "./Photo.vue"

export default {
  name: "PreprAsset",
  components: { PreprDocument, PreprPhoto },
  props: {
    /**
     * Prepr data of this element
     */
    data: {
      type: Object,
      default: () => {},
    },
    /**
     * Prop and attribute overwrites
     */
    overwrites: {
      type: Object,
      default: () => {
        return {}
      },
    },
    /**
     * Index
     */
    index: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      // Prepr data model https://developers.prepr.io/reference#assetsid
      dataModel: {
        items: [{
          label: null,
          body: null,
          cdn_files: {
            items: [{
              id: null,
              profile: null,
              url: null,
            }],
          },
          source_file: {
            extension: null,
            original_name: null,
            url: null,
          },
        }],
      },
    }
  },
  computed: {
    normalizedData () {
      return {...this.dataModel, ...this.data}
    },
    renderableAssets () {
      // only render the assets for which a component is available
      return this.normalizedData.items.filter(item => this.$options.components[`Prepr${item.label}`])
    },
    isCarousel () {
      // if every asset in this element is a photo, make a carousel of them
      return this.renderableAssets.length > 1 && this.renderableAssets.every(asset => asset.label === 'Photo')
    },
    carouselAssets () {
      return this.renderableAssets.map((asset) => {
        // Merge description and credits to a caption and makes sure its ends with a period
        const caption = `
          ${asset.body ? asset.body.replace(/([^.])$/, '$1.') : ''}
          ${asset.author ? 'Credits: ' + asset.author.replace(/([^.])$/, '$1.') : ''}
        `
        const ratio = asset.height / asset.width
        return {
          type: 'image',
          thumbnail: asset.cdn_files?.items?.[0]?.url,
          name: asset.name,
          extension: asset.source_file?.extension || asset.cdn_files?.items?.[0]?.profile,
          caption: caption.trim(),
          size: `xs:378x${378 * ratio} sm:675x${675 * ratio} md:900x${900 * ratio} lg:1260x${1260 * ratio}`,
          width: `xs:calc(100vw - 40px) md:675`,
          focus: null, // @todo: add focus information from api
        }
      })
    },
  },
}
